<template>
  <v-text-field
    :prepend-icon="schema.icon"
    :name="name"
    :label="schema.label"
    :value="value"
    :required="!schema.optional"
    :rules="textFieldRules"
    :error-messages="errorMessages"
    @input="handleInput"
    :solo="schema.solo"
  />
</template>
<script>
export default {
  name: 'string',
  props: {
    /** Current Value */
    value: { type: String, default: '' },
    /** Validation Errors */
    errorMessages: { type: String },
    /** Field Name */
    name: { type: String, required: true },
    /** Field Schema */
    schema: { type: Object, default: () => ({}) },
    /** Disabled state */
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      textFieldRules: [
        v => !!v || 'El campo es obligatorio'
      ]
    }
  },
  methods: {
  /** Validation Rules */
  /* validationRules () {
    const rules = [] */
  // Required validation
  /* if (!this.schema.optional) {
    rules.push((v) => !!v || 'Campo requerido.')
    } */
    // Length validations
    /*  if (this.fieldOptions.min) {
      rules.push(
        (v) => !v || v.length >= this.fieldOptions.min! || 'Demasiado corto'
      )
    }
    if (this.fieldOptions.max) {
      rules.push(
        (v) => !v || v.length <= this.fieldOptions.max! || 'Demasiado largo'
    )
    } */
    /* return rules
  }, */
    /** Additional field options */
    /* get fieldOptions () {
    return this.schema.fieldOptions || {}
  }, */
    /** Input event handler */
    handleInput (...args) {
      this.$emit('input', ...args)
    }
  }
}
</script>
